var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1128_2177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9978 4.21777C4.9978 2.00863 6.78866 0.217773 8.9978 0.217773H40.9978C43.2069 0.217773 44.9978 2.00863 44.9978 4.21777V36.2179C44.9978 38.427 43.2069 40.2179 40.9978 40.2179H8.9978C6.78866 40.2179 4.9978 38.427 4.9978 36.2179V4.21777Z",
    fill: "#FDFEFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2317 36.2179C40.2069 36.2179 40.9978 35.4271 40.9978 34.4518V5.9839C40.9978 5.0084 40.2069 4.21777 39.2317 4.21777H10.7639C9.7883 4.21777 8.9978 5.0084 8.9978 5.9839V34.4518C8.9978 35.4271 9.7883 36.2179 10.7639 36.2179H39.2317Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0773 36.2178V23.8257H35.2369L35.8597 18.9963H31.0773V15.9128C31.0773 14.5145 31.4657 13.5617 33.4708 13.5617L36.0282 13.5605V9.24116C35.5857 9.18228 34.0677 9.05078 32.3017 9.05078C28.6144 9.05078 26.0902 11.3014 26.0902 15.4347V18.9963H21.9199V23.8257H26.0902V36.2178H31.0773Z",
    fill: "#395185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1128_2177",
    x: 0.997803,
    y: 0.217773,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.686275 0 0 0 0 0.890196 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1128_2177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1128_2177",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9708f1aa1f4a5e65b0a9eb5b9ecf6722.svg";
export { ForwardRef as ReactComponent };